<template>
  <q-item :tag="tag" :dark="dark" :dense="dense" :class="customClass" :style="customStyle">
    <slot />
  </q-item>
</template>

<script>
export default {
  name: 'RItem',
  props: {
    tag: String,
    dark: Boolean,
    dense: Boolean,
    customClass: String,
    customStyle: String,
  },
};
</script>
